import React from 'react';
import { Link } from 'react-router-dom';
import './RecentOrders.css';

const RecentOrders = ({ orders }) => {
  if (!orders || orders.length === 0) {
    return <div className="no-orders">No recent orders</div>;
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  const getStatusColor = (status) => {
    const colors = {
      pending: '#fbbc04',
      confirmed: '#4285f4',
      processing: '#9334e6',
      shipped: '#34a853',
      delivered: '#137333',
      cancelled: '#ea4335',
    };
    return colors[status] || '#9aa0a6';
  };

  return (
    <div className="recent-orders">
      <table className="orders-table">
        <thead>
          <tr>
            <th>Order Number</th>
            <th>Customer</th>
            <th>Total</th>
            <th>Status</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => (
            <tr key={order.id}>
              <td>{order.order_number}</td>
              <td>{order.user?.full_name || order.user?.email || 'N/A'}</td>
              <td>Rs. {parseFloat(order.total).toLocaleString()}</td>
              <td>
                <span
                  className="status-badge"
                  style={{ backgroundColor: getStatusColor(order.status) }}
                >
                  {order.status}
                </span>
              </td>
              <td>{formatDate(order.created_at)}</td>
              <td>
                <Link to={`/orders/${order.id}`} className="view-link">
                  View
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RecentOrders;
